(function ($) {

    var errorMessage = "An unkown error occurred.";
    var forms = $('.js-alarm-form form');

    forms.submit(function (e) {
        e.preventDefault();

        var form = $(this);
        var feedbackContainer = $(form).find('.modal-form__feedback');
        var sendButton = $(form).find('.modal-form__send');

        sendButton.prop('disabled', true);

        $.ajax({
                type: form.attr('method'),
                url: form.attr('action'),
                data: form.serialize()
            })
            .done(function (response) {

                sendButton.prop('disabled', false);

                feedbackContainer.html(response.Message);
                if (response.RedirectTo) {
                    window.location.href = response.redirectTo;
                }

                if (response.Success) {
                    form.replaceWith(feedbackContainer);
                }
                else {
                    feedbackContainer.addClass('modal-form__feedback--error');
                }
            })
            .fail(function () {
                feedbackContainer.addClass('modal-form__feedback--error');
                feedbackContainer.html(errorMessage);
                sendButton.prop('disabled', false);
            });
    });

})(jQuery);